import React, {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import ProductCategoryLicenses from './ProductCategoryLicenses '
import NetworkProfile from './NetworkProfile'
import OfftakerBusinessProfile from './OfftakerBusinessProfile'
import {IItmesConfig} from 'models/GenericForm'
import {Button} from 'helpers'
import {updateOnboardingItmes} from 'utils/api/auth/myAccountService'
import {toast} from 'react-toastify'
import {IFormField} from 'models/Common'
import {USER_CATEGORY} from 'constants/userCategory'
import {useAuth} from 'context/AuthProvider'
import {resolveOrganisationId} from 'utils/helpers/resolveOrganisationId'

type IProps = {
 userId: string
 loggedInUserId: number | undefined
 userCategoryKey?: string
 parentItemConfig?: IItmesConfig
 loader: boolean
 accessDetails: IFormField
 setLoader: (newState: boolean) => void
 reloadTabs: () => void
}

const Index = (props: IProps) => {
 const {t} = useTranslation()
 const {userData} = useAuth()
 const [organisationId, setOrganisationId] = useState<
  number | null
 >(null)

 const isOffTaker =
  props.userCategoryKey === USER_CATEGORY.OFFTAKER_ADMIN ||
  props.userCategoryKey === USER_CATEGORY.OFFTAKER_USER

 const handleUpdateState = async () => {
  const data = props.parentItemConfig
  if (data) {
   const res = await updateOnboardingItmes({
    ...(props.userId && {user_id: props.userId}),
    onboarding_items: [
     {
      id: data.id,
      user_category: data?.user_category,
      item_identifier: data?.item_identifier,
      fields: {},
     },
    ],
   })
   if (res) {
    toast.success(res)
   }
   props.reloadTabs()
  }
 }

 useEffect(() => {
  let cancelled = false

  const loadOrganisationId = async () => {
   if (!isOffTaker) return
   const orgId = await resolveOrganisationId(
    props.userId,
    userData
   )
   if (!cancelled) {
    setOrganisationId(orgId)
   }
  }

  void loadOrganisationId()

  return () => {
   cancelled = true
  }
 }, [isOffTaker, props.userId, userData])

 if (isOffTaker) {
  return (
   <OfftakerBusinessProfile
    userId={props.userId}
    organisationId={organisationId}
    parentItemConfig={props.parentItemConfig}
    reloadTabs={props.reloadTabs}
   />
  )
 }

 return (
  <div className='w-full'>
   <div className='w-full'>
    <div className={`w-full mb-12`}>
     <div className='text-[#33393D] text-lg font-bold'>
      {t(
       'myAccountPage.businessProfile.inputLicense.title'
      )}
     </div>
     {props.accessDetails?.productCategoryLicenses
      ?.canView && (
      <>
       <div className='text-[#33393D] text-lg font-bold my-4'>
        {t(
         'myAccountPage.businessProfile.inputLicense.productCategoryLicense'
        )}
       </div>
       <ProductCategoryLicenses
        accessDetails={
         props.accessDetails?.productCategoryLicenses
        }
        type='input'
        userId={props.userId}
        loggedInUserId={props.loggedInUserId}
       />
      </>
     )}
    </div>
    <div className={`w-full mb-12`}>
     <div className='text-[#33393D] text-lg font-bold my-4'>
      {t(
       'myAccountPage.businessProfile.networkProfile.title'
      )}
     </div>
     <NetworkProfile
      type='output'
      accessDetails={props.accessDetails?.networkProfile}
      userId={props.userId}
      loggedInUserId={props.loggedInUserId}
     />
    </div>
    <div className='w-full'>
     {props.parentItemConfig?.status !== 'COMPLETED' && (
      <div className='flex items-center justify-end '>
       <Button
        onClick={handleUpdateState}
        color='blue'
        className='text-center py-[9px] px-6 bg-[#4E83E4] 
                           !rounded-lg text-base text-white font-semibold border-[#4E83E4]'
       >
        {t('myAccountPage.save')}
       </Button>
      </div>
     )}
    </div>
   </div>
  </div>
 )
}

export default Index
